<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import AuthApi from "@/services/auth-api";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, NprogressContainer,FormWizard, TabContent,WizardStep},
  data() {
    return {
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      forgetPasswordisClicked:false,
      newPassword:"",
      confPassword:"",
      username:"",
      errorMessage:"",
      showErrorMesage:false,
      tryingToCreateCode:false,
      code:"",
      showSecondErrorMessage:false,
      secondErrorMessage:""

    };
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true;
      this.isAuthError = false;
      // Reset the authError if it existed.
      this.authError = null;
      return (
        this.logIn({
          email: this.email,
          password: this.password
        })
          // eslint-disable-next-line no-unused-vars
          .then(token => {

            
            
            this.tryingToLogIn = false;
            this.isAuthError = false;

            // Redirect to the originally requested page, or to the home page
            if (this.$route.query.redirectFrom == "/logout") {
              this.$router.push({ name: "home" });
            } else {
              this.$router.push(
                this.$route.query.redirectFrom || { name: "home" }
            );
            }
          })
          .catch(error => {

            this.tryingToLogIn = false;
            this.authError = error ? error : "";
            this.isAuthError = true;
          })
      );
    },

    openForgetPassword(){
      this.forgetPasswordisClicked=true
      this.newPassword=""
      this.confPassword=""
      this.username=""
      this.errorMessage=""
      this.showErrorMesage=false
      this.tryingToCreateCode=false
      this.code=""
      this.showSecondErrorMessage=false
      this.secondErrorMessage=""
      this.isAuthError=false
    },


    _handleError(error) {
        this.errorMessage=error
        this.showErrorMesage=true
    },

    _handleSecondError(error) {
        this.secondErrorMessage=error
        this.showSecondErrorMessage=true
    },

    createCode () {
      return new Promise((resolve, reject) => {
          AuthApi.createCode(this.username,this.newPassword,this.confPassword)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleError(error));
          });
      });
    },

    resetPassword () {
      return new Promise((resolve, reject) => {
          AuthApi.resetPassword(this.username,this.code)
          .then((result) => {
              resolve(result);
          }, (error) => {
              reject(this._handleSecondError(error));
          });
      });
    },

  

  }
};
</script>

<style lang="scss">
  
  #nprogress .bar {
    background: #2a2c74;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
  border: solid 4px transparent;
  border-top-color: #2a2c74;
  border-left-color: #2a2c74;
  }

  #nprogress .peg {
  box-shadow: 0 0 10px grey, 0 0 5px grey;
  opacity: 1.0;
  }


</style>

<template>
  <Layout class="nprogress-container">
     <div class="row justify-content-center d-xs-none" style="opacity:0.95">
      <nprogress-container></nprogress-container>
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card border-warning overflow-hidden" style="border: 3px solid; border-radius: 10px;">

          <div class="bg-white">
            <div class="row pl-4 pr-4">
              <div class="col-7">
              </div>
              <div class="col-5 pt-4 align-self-end">
                <img src="@/assets/images/logo.png" alt class="img-fluid" />
              </div>
            </div>

            <div class="row pr-4 pt-4 pl-0">
              <div class="col-12 text-right">
                <div class="text-primary pr-2 pl-0 pb-2">
                  <h5 class="text-primary font-weight-bold text-right">Société Industrielle d'Amortisseurs</h5>
                  <span class="text-muted">Tél.: +216 71 130 900,  Email: info@sia-am.com</span><br>
                </div>
              </div>
            </div>

            
          </div>

          <div class="card-body pt-0">
            
            

            <hr/>

            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

            <div v-if="forgetPasswordisClicked">
              <form-wizard  color="#fec235" nextButtonText="Suivant" finish-button-text="Terminer" @on-complete="forgetPasswordisClicked=false">
                  <div slot="prev" scope="props" class="d-none">                      
                  </div>
                  <template slot="step" slot-scope="props">
                    <wizard-step :tab="props.tab"
                    :transition="props.transition"
                    
                    :index="props.index">
                    </wizard-step>
                  </template>
                <tab-content icon="mdi mdi-account-circle"  :before-change="createCode">
                  <div class="row mb-4">
                    <div class="col-12">
                        <b-alert v-show="showErrorMesage" show variant="danger">{{this.errorMessage}}</b-alert>

                        <label class="mb-2" >Adresse Mail</label>
                        <input
                          class="form-control"
                          v-model="username"
                          type="text"
                          placeholder="Adresse Mail"
                          autocomplete="off"
                        />
                        <label class="mb-2 mt-4" for="pwd">Nouveau Mot de passe</label>
                        <input
                          class="form-control"
                          id="pwd"
                          v-model="newPassword"
                          type="password"
                          placeholder="Nouveau Mot de passe"
                          autocomplete="off"
                        />
                        <label class="mb-2 mt-4" for="confpwd">Retapez le nouveau mot de passe</label>
                        <input
                          class="form-control"
                          id="confpwd"
                          v-model="confPassword"
                          type="password"
                          placeholder="Mot de Passe de Confirmation"
                          autocomplete="off"
                        />
                    </div>
                  </div>
                </tab-content>
                <tab-content icon="mdi mdi-lock" :before-change="resetPassword" >
                  <div class="row">
                    <div class="col-12">
                        <b-alert v-show="showSecondErrorMessage" show variant="danger">{{this.secondErrorMessage}}</b-alert>
                        <div class="row mb-4">
                          <div class="col-12 text-center text-danger">
                          <i class="bx bx-hourglass bx-spin mr-2"></i>Un code a été envoyé à l'adresse <span class="font-weight-bold">{{this.username}}. </span> Ce code expire dans <span class="font-weight-bold">15 minutes</span>
                          </div>
                        </div>
                        <input
                          class="form-control mb-4"
                          v-model="code"
                          type="text"
                          placeholder="Saisir le Code"
                          autocomplete="off"
                        />
                    </div>
                  </div>
                </tab-content>
                <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                  <div class="row mb-4">
                    <div class="col-12">
                      <div class="text-center">
                        <h2 class="mt-0">
                          <i class="mdi mdi-check-all text-success"></i>
                        </h2>
                        <h3 class="mt-0">Félicitations !</h3>

                        <p class="w-75 mb-2 mx-auto">
                          Votre mot de passe a été réinitialisé avec succés.
                        </p>

                      </div>
                    </div>
                  </div>
                </tab-content>
              </form-wizard>
              <div class="row">
                <div class="col-12 text-muted text-center" >
                  <i class="mdi mdi-lock mr-1"></i> Vous vous en souvenez ?               
                  <div
                  style="cursor:pointer;"
                  @click="forgetPasswordisClicked=false"
                  class="font-weight-medium text-primary"
                  >Connectez-vous ici</div
                > 
                </div>
              </div>
            </div>

            <b-form  v-else class="p-4" @submit.prevent="tryToLogIn">
              <b-form-group class="text-primary" id="input-group-1" label="Adresse Mail" label-for="input-1">
                <b-form-input class="font-size-16" id="input-1" v-model="email" type="email" placeholder="Votre email"></b-form-input>
              </b-form-group>

              <b-form-group class="text-primary" id="input-group-2" label="Mot de Passe" label-for="input-2">
                <b-form-input
                class="font-size-16"
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Mot de passe"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              
              <div class="mt-5">
                <b-button type="submit" variant="warning" class="btn-block font-weight-bold text-primary font-size-20">Connecter</b-button>
              </div>
              <div class="mt-4 text-center text-info font-size-15">
              </div>
              <div class="mt-3 text-center">
                <!-- <router-link tag="a" to="/forgot-password" class="text-muted"> -->
                <div class="text-muted" @click="openForgetPassword" style="cursor: pointer">
                  <i class="mdi mdi-lock mr-1"></i> Vous avez oublié votre mot de passe ?
                </div>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->

          <div class="card-footer bg-transparent border-top">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Site web" href="https://www.sia-am.com/" style="cursor: pointer" target="_blank" >
                  <i class="fas fa-globe text-muted"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Facebook" href="https://www.facebook.com/AmortisseursTunisie" style="cursor: pointer" target="_blank" >
                  <i class="fab fa-facebook-square text-muted"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Linkedin" href="https://www.linkedin.com/company/sia-tunisia/" style="cursor: pointer" target="_blank">
                  <i class="fab fa-linkedin text-muted"></i>
                </a>
              </div>
                
            </div>
          </div>
          
        </div>
        <!-- end card -->

        <div class="mt-5 font-weight-bold font-size-16 text-light text-center">
          
          <p>
            <a href="http://www.amiral.io"  target="_blank" class="text-white">
            © {{new Date().getFullYear()}} Amiral
            </a>
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
